import Vue from "vue";
import IkLoading from "@/components/loading/index";
import { Dialog } from "element-ui";

const ElDialog = Vue.extend(Dialog);

Vue.mixin({
    methods: {
        $dynamicCreate(tag, props = {}) {
            let component = Vue.extend(tag);
            let div = document.createElement("div");
            let instance = new component({
                el: div,
                propsData: props,
            });

            document.body.appendChild(instance.$el);

            return {
                close: () => {
                    instance.$el.remove();
                    instance.$destroy();
                    div.remove();
                },
                instance,
            };
        },
        $loading(text) {
            let data = this.$dynamicCreate(IkLoading, {
                text,
            });
            data.instance.visible = true;
            return data;
        },
        // prettier-ignore
        $openDialog(component, props = {}) {
            const showCancel = props.showCancelButton !== false
            const showConfirm = props.showConfirmButton !== false
            const cancelText = props.cancelButtonText || '取消'
            const confirmText = props.confirmButtonText || '确认'
            let context = null;
            let dialog = null;
            const promise = new Promise((resolve, reject) => {
                context = this.$createElement(component || "div", {
                    props: props.data || {},
                });
                let div = document.createElement("div");
                dialog = new ElDialog({
                    el: div,
                    propsData: {
                        ...props,
                        visible: true,
                        destroyOnClose: true,
                        modalAppendToBody: false,
                        top: '',
                        beforeClose: () => {
                            dialog.$props.visible = false;
                        },
                    },
                });
                dialog.$slots.default = [context];
                dialog.$slots.footer = [
                    this.$createElement(
                        "div", { class: "custom-footer", }, [ 
                            showConfirm ? this.$createElement("el-button", { props: { type: "primary", }, on: { click: async () => {
                                // 点击确认
                                if (
                                    typeof context.componentInstance
                                        .beforeClose == "function"
                                ) {
                                    let data = await context.componentInstance.beforeClose();
                                    resolve(data);
                                }
                                dialog.$props.visible = false;
                            }, }, }, [confirmText] ) : null,
                            showCancel ? this.$createElement("el-button", { on: { click: () =>
                                (dialog.$props.visible = false),
                            }, }, [cancelText]) : null,
                        ]
                    ),
                ];
                dialog.$on("closed", () => {
                    dialog.$destroy();
                    dialog.$el.remove();
                    div.remove();
                });
                document.body.appendChild(dialog.$el);
                dialog.$el.classList.add('custom-dialog')
            });

            Object.assign(promise, {
                close: () => {
                    dialog.$props.visible = false;
                },
                instance: context,
                dialog,
            });

            return promise;
        }
    },
});
